import { InputHTMLAttributes } from 'react';
import { FieldMetaState } from 'react-final-form';

import { getMetaError } from 'shared/functions/errors';

type Props = {
  input: InputHTMLAttributes<HTMLInputElement>;
  disabled?: boolean;
  meta?: FieldMetaState<any>;
};
export const DatePicker = ({ input, meta, ...rest }: Props) => {
  const error = getMetaError(meta);

  return (
    <div data-testid={input.name} key={input.name}>
      <input
        className="form-control"
        type="date"
        id={input.name}
        value={input.value}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error TODO This type is incorrect
        onChange={(evt) => input.onChange?.(evt.target.value)}
        disabled={rest.disabled}
        max={9999}
        {...rest}
      />
      {error && <div className="errorMsg">{error}</div>}
    </div>
  );
};
